import {writable} from "svelte/store";

export const initialTokenDetail = () => {
    return {
        tokenName: "",
        tokenSymbol: "",
        projectTokenPrice: "",
        initialSupply: "",
        tokenDetails: ""
    }
}


const tokenDetailPermissionless = () => {
    const { subscribe, update, set } = writable(initialTokenDetail())

    return {
        subscribe,
        setProjectTokenDetail: ({...fields}) => update(n => ({...n, ...fields })),
        reset: () => set(initialTokenDetail())
    }
}

export const tokenDetailStore = tokenDetailPermissionless()